import { createModel } from '@rematch/core'
import * as firebase from 'firebase'

interface ICouponState {
  [couponId: string]: ICoupon
}

export default createModel({
  state: {} as ICouponState,
  reducers: {
    updateById: (state: ICouponState, payload: { couponId: string, coupon: ICoupon }): ICouponState => ({
      ...state, [payload.couponId]: payload.coupon
    }),
  },
  effects: {
    async fetchCoupon(couponId: string) {
      const snap = await firebase.firestore().collection('coupons').doc(couponId).get()
      const coupon = snap.data() as ICoupon
      this.updateById({ couponId, coupon })
    },
  },
  selectors: {
    getById: (state: ICouponState, couponId: string) => {
      return state[couponId] ? state[couponId] : null
    },
  }
})


// WEBPACK FOOTER //
// ./src/models/coupons.ts